module.exports = __webpack_public_path__ + "img/baking-ingredients4.1cf5ba65.jpeg";